import { useState, useEffect } from 'react';

const useTypingEffect = (text, speed = 100, startDelay = 0) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  // Reset internal state whenever the input `text` changes
  useEffect(() => {
    setDisplayedText('');
    setCurrentIndex(0);
    setIsComplete(false);
  }, [text]);

  // Handle optional start delay
  useEffect(() => {
    if (startDelay > 0) {
      const delayTimeout = setTimeout(() => {
        // No-op: the reset above ensures currentIndex starts at 0
      }, startDelay);
      return () => clearTimeout(delayTimeout);
    }
    return undefined;
  }, [startDelay]);

  useEffect(() => {
    // If there's nothing to type, mark complete and return
    if (!text || text.length === 0) {
      setDisplayedText('');
      setIsComplete(true);
      return undefined;
    }

    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => text.slice(0, currentIndex + 1));
        setCurrentIndex(prev => prev + 1);
      }, speed);

      return () => clearTimeout(timeout);
    }

    if (currentIndex >= text.length) {
      setIsComplete(true);
    }

    return undefined;
  }, [currentIndex, text, speed]);

  return { displayedText, isComplete };
};

export default useTypingEffect;